import { Icon, Input, InputAdornment } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useGlobalFilter } from '../../shared/hooks/useGlobalFilter';

function FilterInputSearchCustom({
    placeholder = "Cari",
    searchInput,
    setSearchInput,
    resetOnMount,
    resetOnUnmount,
    ...props
}) {
    const { filter, setFilter, resetFilter } = useGlobalFilter();

    useEffect(() => {
        if (resetOnMount) {
            resetFilter("search");
        }
        // return () => {
        //     if (resetOnUnmount) {
        //         resetFilter("search");
        //     }
        // };
    }, [resetFilter, resetOnMount, resetOnUnmount]);

    return (
        <Input
            autoFocus
            disableUnderline
            fullWidth
            startAdornment={
                <InputAdornment position="start">
                    <Icon className="text-primary-main">search</Icon>
                </InputAdornment>
            }
            onChange={(e) => setFilter({ search: e.target.value })}
            value={filter.search}
            // onChange={(e) => setSearchInput(e.target.value)}
            // value={searchInput}
            placeholder={placeholder}
            {...props}
        />
    )
}

export default FilterInputSearchCustom